/**
 * Tenant service utility functions for tenant type management
 *
 * Usage examples:
 *
 * // Check if tenant is institutional monitoring
 * import { isInstitutionalMonitoring } from '../utils/tenantService'
 * const isInstitutional = isInstitutionalMonitoring(profile)
 *
 * // Get tenant type
 * import { getTenantType } from '../utils/tenantService'
 * const type = getTenantType(profile) // Returns 'INSTITUTIONAL_MONITORING' or null
 *
 * // Use with hook
 * import useTenantType from '../hooks/useTenantType'
 * const { isInstitutionalMonitoring, tenantType } = useTenantType()
 */

export const TENANT_TYPES = {
    INSTITUTIONAL_MONITORING: 'INSTITUTIONAL_MONITORING'
    // Add other tenant types as needed
}

/**
 * Check if the current user's tenant type is INSTITUTIONAL_MONITORING
 * @param {Object} profile - User profile object containing tenant information
 * @returns {boolean} - True if tenant type is INSTITUTIONAL_MONITORING
 */
export const isInstitutionalMonitoring = (profile) => {
    return profile?.tenant?.tenantType === TENANT_TYPES.INSTITUTIONAL_MONITORING
}

/**
 * Get the tenant type from profile
 * @param {Object} profile - User profile object containing tenant information
 * @returns {string|null} - Tenant type or null if not available
 */
export const getTenantType = (profile) => {
    return profile?.tenant?.tenantType || null
}

/**
 * Check if tenant type matches a specific type
 * @param {Object} profile - User profile object containing tenant information
 * @param {string} tenantType - Tenant type to check against
 * @returns {boolean} - True if tenant type matches
 */
export const isTenantType = (profile, tenantType) => {
    return profile?.tenant?.tenantType === tenantType
}

/**
 * Get tenant information from profile
 * @param {Object} profile - User profile object containing tenant information
 * @returns {Object|null} - Tenant object or null if not available
 */
export const getTenantInfo = (profile) => {
    return profile?.tenant || null
}
